const PasswordLength = ({ className }) => {
  const defaultStyle =
    'w-[70px] md:w-[100px] h-[5px] bg-[#7A7A7A] rounded-[100px]';
  return <div className={`${className} ${defaultStyle}`}></div>;
};

export default PasswordLength;
